import { Component, EventEmitter, Input, Output } from '@angular/core';
import { measureOptions } from 'src/app/shared/utils/map-utils';

@Component({
    selector: 'atlas-map-measure-control',
    templateUrl: './map-measure-control.component.html',
    styleUrl: './map-measure-control.component.less',
    standalone: false
})
export class MapMeasureControlComponent {
  @Input() measurement: number = 0;
  @Input() measureMode: boolean;

  @Output() close = new EventEmitter<void>();
  @Output() measureOptionClicked = new EventEmitter<measureOptions>();

  onCloseClicked() {
    this.measureMode = false;
    this.close.emit();
  }

  onMeasuredMapClicked(option: measureOptions) {
    this.measureMode = true;
    this.measureOptionClicked.emit(option);
  }
}
